// Espace Propriétaire — fiche employé (réutilise le détail de l'espace Agence).
import AgenceEmployeDetailPage from "@/pages/agence/employes/detail/page";

export default function ProprietaireEmployeDetailPage() {
  return <AgenceEmployeDetailPage />;
}